import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin, Calendar, Settings, Users, Layers, ChevronRight } from 'lucide-react';
import Header from '../../components/Header';
import { useAuth } from '../../context/AuthContext';

/**
 * Liste des sections d'administration disponibles.
 * Pour ajouter une nouvelle fonctionnalité d'admin plus tard, il suffit
 * d'ajouter une entrée ici (et sa route dans App.js) — le tableau de bord
 * l'affichera automatiquement.
 */
const ADMIN_SECTIONS = [
  {
    key: 'venues',
    title: 'Lieux (casinos)',
    description: 'Ajouter, modifier ou supprimer les casinos et salles de poker',
    icon: MapPin,
    path: '/admin/venues',
    color: 'bg-blue-600',
  },
  {
    key: 'circuits',
    title: 'Circuits',
    description: 'Ajouter, modifier ou supprimer les circuits de tournois',
    icon: Layers,
    path: '/admin/circuits',
    color: 'bg-orange-600',
  },
  {
    key: 'festivals',
    title: 'Festivals',
    description: 'Gérer les festivals et leurs tournois',
    icon: Calendar,
    path: '/manage-festivals',
    color: 'bg-purple-600',
  },
  {
    key: 'users',
    title: 'Utilisateurs',
    description: "Gérer les comptes, les rôles et les accès administrateur",
    icon: Users,
    path: '/admin/users',
    color: 'bg-green-600',
  },
];

const AdminDashboardPage = () => {
  const navigate = useNavigate();
  const { userRole } = useAuth();

  if (userRole !== 'admin') {
    return (
      <div className="min-h-screen bg-gray-50">
        <Header />
        <div className="container mx-auto px-4 py-8">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-red-600 mb-4">Accès refusé</h2>
            <p className="text-gray-600 mb-6">Vous devez être administrateur pour accéder à cette page.</p>
            <button
              onClick={() => navigate('/')}
              className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
            >
              Retour à l'accueil
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      <div className="container mx-auto px-4 py-8">
        <div className="max-w-5xl mx-auto">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-800 flex items-center">
              <Settings className="mr-3" size={32} />
              Administration
            </h1>
            <p className="text-gray-600 mt-2">Gérez les données de l'application</p>
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            {ADMIN_SECTIONS.map((section) => {
              const Icon = section.icon;
              return (
                <button
                  key={section.key}
                  onClick={() => navigate(section.path)}
                  className="bg-white rounded-lg shadow-lg p-6 text-left hover:shadow-xl transition flex items-center gap-4"
                >
                  <div className={`${section.color} p-3 rounded-lg text-white flex-shrink-0`}>
                    <Icon size={28} />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-800">{section.title}</h3>
                    <p className="text-gray-600 text-sm mt-1">{section.description}</p>
                  </div>
                  <ChevronRight className="text-gray-400" size={24} />
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardPage;
